import script from "./GarmentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GarmentComponent.vue?vue&type=script&setup=true&lang=js"

import "./GarmentComponent.vue?vue&type=style&index=0&id=783ba50a&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783ba50a"]])

export default __exports__